import React, { useContext, useState } from 'react';
import styles from '../../../css/components/main-wrappers/foe/belowTheFoldWrapperFoe.css';

import Footer from '../../footers/StandardFooter';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';
import { Trans, useTranslation } from 'react-i18next';
import { INNOGAMES_LINK } from '../../common/links/InnoGamesLink';
import TrailerThumbnail from '../../../img/foe/thumbnails/screenshot-foe-trailer-preview.jpg';
import MapThumbnail from '../../../img/foe/thumbnails/screenshots-foe-city-map-thumb.jpg';
import MapScreenshot from '../../../img/foe/screenshots/screenshots-foe-city-map-571.jpg';
import BattleThumbnail from '../../../img/foe/thumbnails/screenshots-foe-strategic-battle-thumb.jpg';
import BattleScreenshot from '../../../img/foe/screenshots/screenshots-foe-strategic-battle-571.jpg';
import { getAssetUrl } from '../../../helpers/get-asset-url';
import LazyImage from '../../common/LazyImage';
import MediaContent from '../../content/MediaContent';
import CSSAnimation from '../../common/CSSAnimation';
import UskSection from '../../common/UskSection';

const INNOGAMES_FOE_LINK = 'https://www.innogames.com/games/forge-of-empires/';

function BelowTheFoldWrapper() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const { t } = useTranslation('translation');

	const [showTrailer, setShowTrailer] = useState(false);
	const [showScreenshots, setShowScreenshots] = useState(false);
	const [initialMediaIndex, setInitialMediaIndex] = useState(0);

	const gameLinks = onelpsParams.otherGames;

	const handleTrailerThumbnailClick = () => setShowTrailer(true);
	const handleMapThumbnailClick = () => {
		setInitialMediaIndex(0);
		setShowScreenshots(true);
	};
	const handleBattleThumbnailClick = () => {
		setInitialMediaIndex(1);
		setShowScreenshots(true);
	};

	const forumLink = `https://forum.${onelpsParams.marketId}.forgeofempires.com/`;

	const showUskLabel = onelpsParams.uskLabel?.show && onelpsParams.uskLabel?.belowTheFold && onelpsParams.country === 'DE';

	return (
		<section className={styles.belowTheFoldWrapper}>
			<CSSAnimation
				delayUntilUnmountInMillis={300}
				isMounted={showTrailer}
				mountClassName={`${styles.mediaContentAnimation} ${styles.visible}`}
				unmountClassName={`${styles.mediaContentAnimation} ${styles.hide}`}
			>
				<MediaContent
					imagesSrc={[]}
					onClose={() => setShowTrailer(false)}
					isVideo
					videoSrc={'https://www.youtube.com/embed/e11X1Jl_lMk?si=GB3RKtC_y_RlnqO8'}
					dataTestId={'trailerOverlay'}
				/>
			</CSSAnimation>
			<CSSAnimation
				delayUntilUnmountInMillis={300}
				isMounted={showScreenshots}
				mountClassName={`${styles.mediaContentAnimation} ${styles.visible}`}
				unmountClassName={`${styles.mediaContentAnimation} ${styles.hide}`}
			>
				<MediaContent
					initialMediaIndex={initialMediaIndex}
					imagesSrc={[MapScreenshot, BattleScreenshot]}
					onClose={() => setShowScreenshots(false)}
					isVideo={false}
					showPaginator
					captionTexts={[t('belowTheFold.foe.thumbnail.map.title'), t('belowTheFold.foe.thumbnail.battle.title')]}
					dataTestId={'screenshotOverlay'}
				/>
			</CSSAnimation>
			{onelpsParams.footer.show && (
				<Footer
					showLogo={false}
					showMoreGamesLinkList
				/>
			)}
			<main className={styles.belowTheFoldContentWrapper}>
				<h1>{t('headTags.pageTitle.foe')}</h1>

				<h2>{t('belowTheFold.foe.heading1')}</h2>
				<p>{t('belowTheFold.foe.paragraph1')}</p>

				<h2>{t('belowTheFold.foe.heading2')}</h2>
				<p>
					<Trans i18nKey='translation:belowTheFold.foe.paragraph2'>
						Forge of Empires (FOE) was published in 2012 as the newest strategy online game by InnoGames and has since been one of the most successful browser-based games available. InnoGames, known as a publisher of high quality titles such as the strategy game&nbsp;
						<a
							href={gameLinks.staemme?.url}
							rel="noreferrer"
							target="_blank"
							title={t('belowTheFold.foe.linkTitle.tribalWars')}
						>
							Tribal Wars
						</a>
						&nbsp;and the Greek empire game&nbsp;
						<a
							href={gameLinks.grepo?.url}
							rel="noreferrer"
							target="_blank"
							title={t('belowTheFold.foe.linkTitle.grepolis')}
						>
							Grepolis
						</a>,
						&nbsp;is combining strategic game-play in an empire builder with excellent visual appeal. But excellent quality, however, is not the only thing unique about Forge of Empires: like all strategy games by&nbsp;
						<a
							href={INNOGAMES_LINK}
							rel="noreferrer"
							target="_blank"
							title="InnoGames"
						>
							InnoGames
						</a>,&nbsp;
						&nbsp;a huge community has developed, bringing players from all over the world together.
					</Trans>
				</p>

				<h2>{t('belowTheFold.foe.heading3')}</h2>
				<div
					className={`${styles.contentImage} ${styles.trailerThumbnail}`}
					onClick={() => handleTrailerThumbnailClick()}
					data-testid='trailerThumbnail'
				>
					<LazyImage
						src={getAssetUrl() + TrailerThumbnail}
						alt={t('belowTheFold.foe.heading3')}
					/>
					<div className={styles.thumbnailFrame}></div>
				</div>
				<p>{t('belowTheFold.foe.paragraph3')}</p>
				<br />

				<h2>{t('belowTheFold.foe.heading4')}</h2>
				<p>{t('belowTheFold.foe.paragraph4')}</p>

				<h2>{t('belowTheFold.foe.heading5')}</h2>
				<div className={styles.imageThumbnailWrapper}>
					<div
						className={styles.contentImage}
						onClick={() => handleMapThumbnailClick()}
						data-testid='mapThumbnail'
					>
						<LazyImage
							src={getAssetUrl() + MapThumbnail}
							alt={t('belowTheFold.foe.thumbnail.map.altText')}
							title={t('belowTheFold.foe.thumbnail.map.title')}
						/>
						<div className={styles.thumbnailFrame}></div>
					</div>


					<div
						className={styles.contentImage}
						onClick={() => handleBattleThumbnailClick()}
						data-testid='battleThumbnail'
					>
						<LazyImage
							src={getAssetUrl() + BattleThumbnail}
							alt={t('belowTheFold.foe.thumbnail.battle.altText')}
							title={t('belowTheFold.foe.thumbnail.battle.title')}
						/>
						<div className={styles.thumbnailFrame}></div>
					</div>

				</div>

				<h2>{t('belowTheFold.foe.heading6')}</h2>
				<ul>
					<li>
						<a
							href={INNOGAMES_FOE_LINK}
							rel="noreferrer"
							target="_blank"
							title={t('belowTheFold.foe.linkText1')}
						>
							{t('belowTheFold.foe.linkText1')}
						</a>
					</li>
					<li>
						<a
							href={forumLink}
							rel="noreferrer"
							target="_blank"
							title={t('belowTheFold.foe.linkText2')}
						>
							{t('belowTheFold.foe.linkText2')}
						</a>
					</li>
				</ul>

				<h2>{t('belowTheFold.foe.heading7')}</h2>
				<p>
					<a
						href={INNOGAMES_LINK}
						rel="noreferrer"
						target="_blank"
						title={t('belowTheFold.foe.linkText3')}
					>
						{`» ${t('belowTheFold.foe.linkText3')}`}
					</a>
				</p>

				<h2>{t('belowTheFold.foe.heading8')}</h2>
				{showUskLabel && (
					<UskSection />
				)}
			</main>
		</section>
	);
}

export default BelowTheFoldWrapper;
